module.exports = __webpack_public_path__ + "static/damaged-item-38c23e03c659826e35628c671ede7a7a.jpg";